import React from "react";
import InfiniteTable from "../../../components/InfiniteTable/InfiniteTable";
import { Container } from "@mui/material";

const columns = [
  { id: "id", editable: "/customer", editablePk: "company_location", label: "Order Guide ID" },
  {
    id: "company_location_name",
    label: "Customer Location",
  },
  { id: "public_name", editable: "/demo", editablePk: "public_name_formatted", label: "View" },
];

export const Orderlists = (props) => {
  return (
    <>
      <Container>
        <InfiniteTable
          {...props}
          apiep="orderlists?public=true"
          columns={columns}
          data={null}
          dataMapByColumn="id"
          deletable={false}
          editable={true}
          filterable={true}
          label="Public Order Guide"
          fetchingModal={null}
        />
      </Container>
    </>
  );
};

export default Orderlists;
